import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const LanguageContext = createContext(null);

const translations = {
  es: {
    // Navigation
    'nav.explore': 'Explorar',
    'nav.myActivities': 'Mis Actividades',
    'nav.profile': 'Perfil',
    'nav.dashboard': 'Panel',
    'nav.login': 'Iniciar Sesión',
    'nav.register': 'Registrarse',
    'nav.logout': 'Cerrar Sesión',
    'nav.alerts': 'Alertas',
    'nav.messages': 'Mensajes',
    'nav.legal': 'Legal',
    'nav.help': 'Ayuda',
    'nav.contact': 'Contacto',
    'nav.language': 'Idioma',
    
    // Categories
    'category.bienestar': 'Bienestar',
    'category.causas': 'Causas',
    'category.charlas': 'Charlas',
    'category.comida': 'Comida',
    'category.creativo': 'Creativo',
    'category.cultura': 'Cultura',
    'category.innovacion': 'Innovación',
    'category.naturaleza': 'Naturaleza',
    'category.all': 'Todas',
    
    // Activity
    'activity.reserve': 'Reservar',
    'activity.waitlist': 'Lista de espera',
    'activity.share': 'Compartir',
    'activity.follow': 'Seguir',
    'activity.following': 'Siguiendo',
    'activity.free': 'Gratis',
    'activity.spots': 'lugares disponibles',
    'activity.spot': 'lugar',
    'activity.spotsPlural': 'lugares',
    'activity.fullCapacity': 'Cupo lleno',
    'activity.minAge': 'Edad mínima',
    'activity.years': 'años',
    'activity.date': 'Fecha',
    'activity.time': 'Horario',
    'activity.location': 'Ubicación',
    'activity.gallery': 'Galería',
    'activity.faq': 'Preguntas Frecuentes',
    'activity.reviews': 'Opiniones',
    'activity.about': 'Acerca de',
    'activity.perPerson': 'por persona',
    'activity.showAllPhotos': 'Ver todas las fotos',
    'activity.viewOnMap': 'Ver en mapa',
    'activity.onlyView': 'Solo visualización',
    
    // Auth
    'auth.email': 'Correo electrónico',
    'auth.password': 'Contraseña',
    'auth.name': 'Nombre completo',
    'auth.loginTitle': 'Bienvenido de vuelta',
    'auth.registerTitle': 'Crear cuenta',
    'auth.loginButton': 'Iniciar sesión',
    'auth.registerButton': 'Crear cuenta',
    'auth.googleLogin': 'Continuar con Google',
    'auth.noAccount': '¿No tienes cuenta?',
    'auth.hasAccount': '¿Ya tienes cuenta?',
    'auth.createOne': 'Crear una',
    'auth.loginHere': 'Inicia sesión',
    'auth.asUser': 'Como usuario',
    'auth.asCreator': 'Como creador',
    
    // Profile
    'profile.edit': 'Editar perfil',
    'profile.activities': 'Actividades',
    'profile.pastActivities': 'Actividades pasadas',
    'profile.reservations': 'Mis reservas',
    'profile.waitlist': 'Lista de espera',
    'profile.bio': 'Biografía',
    'profile.socialLinks': 'Redes sociales',
    'profile.notifications': 'Alertas',
    'profile.notifEnabled': 'Alertas activadas',
    'profile.notifDisabled': 'Activar alertas',
    'profile.notifBlocked': 'Bloqueadas en tu navegador',
    'profile.notifDesc': 'Recibe alertas de pagos, mensajes y más',
    'profile.activate': 'Activar',
    'profile.deactivate': 'Desactivar',
    
    // Dashboard
    'dashboard.title': 'Panel de Creador',
    'dashboard.createActivity': 'Crear actividad',
    'dashboard.myActivities': 'Mis actividades',
    'dashboard.coupons': 'Cupones',
    'dashboard.stats': 'Estadísticas',
    'dashboard.totalRegistrations': 'Total de registros',
    'dashboard.avgRating': 'Calificación promedio',
    'dashboard.tabs.active': 'Mis actividades',
    'dashboard.tabs.reservations': 'Reservas',
    'dashboard.tabs.past': 'Pasadas',
    'dashboard.tabs.coupons': 'Cupones',
    'dashboard.tabs.payments': 'Pagos',
    'dashboard.tabs.analytics': 'Analytics',
    'dashboard.revenue': 'Ingresos',
    'dashboard.confirmedPayments': 'Pagos confirmados',
    'dashboard.pendingPayments': 'Pagos pendientes',
    'dashboard.expectedTotal': 'Total esperado',
    'dashboard.reservations': 'reservas',
    
    // Forms
    'form.title': 'Título',
    'form.shortDesc': 'Descripción corta',
    'form.longDesc': 'Descripción larga',
    'form.category': 'Categoría',
    'form.coverImage': 'Imagen de portada',
    'form.gallery': 'Galería',
    'form.date': 'Fecha',
    'form.time': 'Horario',
    'form.capacity': 'Cupo',
    'form.address': 'Dirección',
    'form.city': 'Ciudad',
    'form.minAge': 'Edad mínima',
    'form.price': 'Precio',
    'form.paymentLink': 'Link de pago',
    'form.save': 'Guardar',
    'form.cancel': 'Cancelar',
    'form.delete': 'Eliminar',
    
    // Messages
    'msg.loading': 'Cargando...',
    'msg.noResults': 'No se encontraron resultados',
    'msg.error': 'Ocurrió un error',
    'msg.success': 'Operación exitosa',
    'msg.registered': '¡Te has registrado exitosamente!',
    'msg.addedToWaitlist': 'Te has añadido a la lista de espera',
    'msg.copied': 'Link copiado al portapapeles',
    
    // Search
    'search.placeholder': 'Buscar actividades...',
    'search.noResults': 'No se encontraron actividades',
    'search.location': 'Ubicación',
    'search.filteringBy': 'Filtrando por',
    
    // Notifications
    'notif.title': 'Alertas',
    'notif.markAllRead': 'Marcar leídas',
    'notif.empty': 'No tienes alertas',
    'notif.emptyDesc': 'Las alertas de reservas y mensajes aparecerán aquí',
    
    // Chat Messages
    'messages.title': 'Mensajes',
    'messages.empty': 'No tienes mensajes',
    'messages.emptyDesc': 'Los mensajes con creadores aparecerán aquí',
    'messages.placeholder': 'Escribe un mensaje...',
    'messages.startConversation': 'Inicia la conversación',
    
    // Legal & Help
    'legal.title': 'Términos de uso y privacidad',
    'legal.contact': '¿Tienes dudas?',
    'legal.contactDesc': 'Contáctanos y te ayudaremos',
    'help.title': 'Centro de ayuda',
    'help.notFound': '¿No encontraste lo que buscabas?',
    'help.contactDesc': 'Contáctanos y te ayudaremos',

    // Contact
    'contact.purpose': 'Nuestro propósito',
    'contact.purposeText': 'Que las personas vivan, hagan y compartan lo que les apasiona.',
    'contact.seeking': 'Buscamos',
    'contact.seekingText': 'Sumar valor y ayudar a que los Creadores de actividades generen ingresos haciendo lo que les apasiona y que los Exploradores de las actividades vivan experiencias de valor que nutran su vida.',
    'contact.generalDesc': 'Si tienes alguna pregunta, sugerencia o propuesta de negocio envía un mensaje en nuestras redes sociales',
    'contact.supportDesc': 'Si hay algo en lo que te podamos apoyar con el funcionamiento del servicio envía un correo',
    
    // Checkout
    'checkout.title': 'Reservar',
    'checkout.quantity': 'Cantidad de lugares',
    'checkout.spotsAvailable': 'lugares disponibles',
    'checkout.noSpots': 'Sin lugares',
    'checkout.yourInfo': 'Tus datos',
    'checkout.summary': 'Resumen',
    'checkout.pricePerPerson': 'Precio por persona',
    'checkout.quantity_label': 'Cantidad',
    'checkout.discount': 'Descuento',
    'checkout.total': 'Total',
    'checkout.confirm': 'Confirmar reserva',
    'checkout.couponPlaceholder': 'Código de cupón',
    'checkout.apply': 'Aplicar',
    'checkout.paymentPending': 'Pago pendiente',
    'checkout.paymentConfirmed': 'Pago confirmado',
    'checkout.paymentInstructions': 'Instrucciones de pago',
    'checkout.paymentLink': 'Ir a pagar',
    'checkout.bankTransfer': 'Transferencia bancaria',
    'checkout.refCode': 'Código de referencia',
    'checkout.backToActivity': 'Volver a la actividad',
    'checkout.backToHome': 'Volver al inicio',
    'checkout.registered': '¡Registro exitoso!',
    'checkout.registeredFree': 'Tu lugar está confirmado',
    
    // My Activities
    'myActivities.title': 'Mis Actividades',
    'myActivities.reservations': 'Reservas',
    'myActivities.favorites': 'Favoritos',
    'myActivities.waitlist': 'En espera',
    'myActivities.paymentConfirmed': 'Pago confirmado',
    'myActivities.paymentPending': 'Pago pendiente',
    'myActivities.noReservations': 'No tienes reservas activas',
    'myActivities.noFavorites': 'No tienes favoritos',
    'myActivities.noWaitlist': 'No estás en ninguna lista de espera',
    'myActivities.explore': 'Explorar actividades',
    'myActivities.pastActivity': 'Actividad pasada',
    'myActivities.pastActivities': 'Actividades pasadas',
    'myActivities.cancelledBooking': 'Reserva cancelada',
    'myActivities.cancelled': 'Cancelada',
    
    // Admin
    'admin.title': 'Panel de Admin',
    'admin.summary': 'Resumen',
    'admin.revenue': 'Ingresos',
    'admin.users': 'Usuarios',
    'admin.activities': 'Actividades',
    'admin.creators': 'Creadores',
    'admin.registrations': 'Registros',
    'admin.searchUsers': 'Buscar usuarios...',
    'admin.searchActivities': 'Buscar actividades...',
    'admin.all': 'Todos',
    'admin.confirmedRevenue': 'Ingresos confirmados',
    'admin.pendingRevenue': 'Ingresos pendientes',
    'admin.revenueByCreator': 'Ingresos por creador',
    'admin.revenueByMonth': 'Ingresos por mes',
    'admin.noRevenueData': 'Sin datos de ingresos',
    'admin.payments': 'pago(s)',
    
    // Common
    'common.back': 'Volver',
    'common.share': 'Compartir',
    'common.save': 'Guardar',
    'common.free': 'Gratis',
    'common.perPerson': 'por persona',
    'common.showAllPhotos': 'Ver todas las fotos',
    'common.confirmed': 'Confirmado',
    'common.pending': 'Pendiente',
    'common.waiting': 'En espera',
  },
  en: {
    // Navigation
    'nav.explore': 'Explore',
    'nav.myActivities': 'My Activities',
    'nav.profile': 'Profile',
    'nav.dashboard': 'Dashboard',
    'nav.login': 'Login',
    'nav.register': 'Sign Up',
    'nav.logout': 'Logout',
    'nav.alerts': 'Alerts',
    'nav.messages': 'Messages',
    'nav.legal': 'Legal',
    'nav.help': 'Help',
    'nav.contact': 'Contact',
    'nav.language': 'Language',
    
    // Categories
    'category.bienestar': 'Wellness',
    'category.causas': 'Causes',
    'category.charlas': 'Talks',
    'category.comida': 'Food',
    'category.creativo': 'Creative',
    'category.cultura': 'Culture',
    'category.innovacion': 'Innovation',
    'category.naturaleza': 'Nature',
    'category.all': 'All',
    
    // Activity
    'activity.reserve': 'Reserve',
    'activity.waitlist': 'Join Waitlist',
    'activity.share': 'Share',
    'activity.follow': 'Follow',
    'activity.following': 'Following',
    'activity.free': 'Free',
    'activity.spots': 'spots available',
    'activity.spot': 'spot',
    'activity.spotsPlural': 'spots',
    'activity.fullCapacity': 'Full',
    'activity.minAge': 'Minimum age',
    'activity.years': 'years',
    'activity.date': 'Date',
    'activity.time': 'Time',
    'activity.location': 'Location',
    'activity.gallery': 'Gallery',
    'activity.faq': 'FAQ',
    'activity.reviews': 'Reviews',
    'activity.about': 'About',
    'activity.perPerson': 'per person',
    'activity.showAllPhotos': 'Show all photos',
    'activity.viewOnMap': 'View on map',
    'activity.onlyView': 'View only',
    
    // Auth
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full name',
    'auth.loginTitle': 'Welcome back',
    'auth.registerTitle': 'Create account',
    'auth.loginButton': 'Sign in',
    'auth.registerButton': 'Create account',
    'auth.googleLogin': 'Continue with Google',
    'auth.noAccount': "Don't have an account?",
    'auth.hasAccount': 'Already have an account?',
    'auth.createOne': 'Create one',
    'auth.loginHere': 'Sign in',
    'auth.asUser': 'As user',
    'auth.asCreator': 'As creator',
    
    // Profile
    'profile.edit': 'Edit profile',
    'profile.activities': 'Activities',
    'profile.pastActivities': 'Past activities',
    'profile.reservations': 'My reservations',
    'profile.waitlist': 'Waitlist',
    'profile.bio': 'Bio',
    'profile.socialLinks': 'Social links',
    'profile.notifications': 'Alerts',
    'profile.notifEnabled': 'Alerts enabled',
    'profile.notifDisabled': 'Enable alerts',
    'profile.notifBlocked': 'Blocked in your browser',
    'profile.notifDesc': 'Get alerts for payments, messages and more',
    'profile.activate': 'Enable',
    'profile.deactivate': 'Disable',
    
    // Dashboard
    'dashboard.title': 'Creator Dashboard',
    'dashboard.createActivity': 'Create activity',
    'dashboard.myActivities': 'My activities',
    'dashboard.coupons': 'Coupons',
    'dashboard.stats': 'Statistics',
    'dashboard.totalRegistrations': 'Total registrations',
    'dashboard.avgRating': 'Average rating',
    'dashboard.tabs.active': 'My activities',
    'dashboard.tabs.reservations': 'Bookings',
    'dashboard.tabs.past': 'Past',
    'dashboard.tabs.coupons': 'Coupons',
    'dashboard.tabs.payments': 'Payments',
    'dashboard.tabs.analytics': 'Analytics',
    'dashboard.revenue': 'Revenue',
    'dashboard.confirmedPayments': 'Confirmed payments',
    'dashboard.pendingPayments': 'Pending payments',
    'dashboard.expectedTotal': 'Expected total',
    'dashboard.reservations': 'bookings',
    
    // Forms
    'form.title': 'Title',
    'form.shortDesc': 'Short description',
    'form.longDesc': 'Long description',
    'form.category': 'Category',
    'form.coverImage': 'Cover image',
    'form.gallery': 'Gallery',
    'form.date': 'Date',
    'form.time': 'Time',
    'form.capacity': 'Capacity',
    'form.address': 'Address',
    'form.city': 'City',
    'form.minAge': 'Minimum age',
    'form.price': 'Price',
    'form.paymentLink': 'Payment link',
    'form.save': 'Save',
    'form.cancel': 'Cancel',
    'form.delete': 'Delete',
    
    // Messages
    'msg.loading': 'Loading...',
    'msg.noResults': 'No results found',
    'msg.error': 'An error occurred',
    'msg.success': 'Operation successful',
    'msg.registered': 'Successfully registered!',
    'msg.addedToWaitlist': 'Added to waitlist',
    'msg.copied': 'Link copied to clipboard',
    
    // Search
    'search.placeholder': 'Search activities...',
    'search.noResults': 'No activities found',
    'search.location': 'Location',
    'search.filteringBy': 'Filtering by',
    
    // Notifications
    'notif.title': 'Alerts',
    'notif.markAllRead': 'Mark all read',
    'notif.empty': 'No alerts',
    'notif.emptyDesc': 'Booking and message alerts will appear here',
    
    // Chat Messages
    'messages.title': 'Messages',
    'messages.empty': 'No messages',
    'messages.emptyDesc': 'Messages with creators will appear here',
    'messages.placeholder': 'Write a message...',
    'messages.startConversation': 'Start the conversation',
    
    // Legal & Help
    'legal.title': 'Terms of use and privacy',
    'legal.contact': 'Have questions?',
    'legal.contactDesc': 'Contact us and we\'ll help',
    'help.title': 'Help Center',
    'help.notFound': 'Didn\'t find what you were looking for?',
    'help.contactDesc': 'Contact us and we\'ll help',

    // Contact
    'contact.purpose': 'Our purpose',
    'contact.purposeText': 'For people to live, do and share what they are passionate about.',
    'contact.seeking': 'We seek',
    'contact.seekingText': 'To add value and help activity Creators earn income doing what they love, and for activity Explorers to live meaningful experiences that enrich their lives.',
    'contact.generalDesc': 'If you have any questions, suggestions, or business proposals, send us a message on our social media',
    'contact.supportDesc': 'If there is anything we can help you with regarding the service, send an email to',
    
    // Checkout
    'checkout.title': 'Book',
    'checkout.quantity': 'Number of spots',
    'checkout.spotsAvailable': 'spots available',
    'checkout.noSpots': 'No spots',
    'checkout.yourInfo': 'Your info',
    'checkout.summary': 'Summary',
    'checkout.pricePerPerson': 'Price per person',
    'checkout.quantity_label': 'Quantity',
    'checkout.discount': 'Discount',
    'checkout.total': 'Total',
    'checkout.confirm': 'Confirm booking',
    'checkout.couponPlaceholder': 'Coupon code',
    'checkout.apply': 'Apply',
    'checkout.paymentPending': 'Payment pending',
    'checkout.paymentConfirmed': 'Payment confirmed',
    'checkout.paymentInstructions': 'Payment instructions',
    'checkout.paymentLink': 'Go to pay',
    'checkout.bankTransfer': 'Bank transfer',
    'checkout.refCode': 'Reference code',
    'checkout.backToActivity': 'Back to activity',
    'checkout.backToHome': 'Back to home',
    'checkout.registered': 'Successfully registered!',
    'checkout.registeredFree': 'Your spot is confirmed',
    
    // My Activities
    'myActivities.title': 'My Activities',
    'myActivities.reservations': 'Bookings',
    'myActivities.favorites': 'Favorites',
    'myActivities.waitlist': 'Waitlist',
    'myActivities.paymentConfirmed': 'Payment confirmed',
    'myActivities.paymentPending': 'Payment pending',
    'myActivities.noReservations': 'No active bookings',
    'myActivities.noFavorites': 'No favorites',
    'myActivities.noWaitlist': 'Not on any waitlist',
    'myActivities.explore': 'Explore activities',
    'myActivities.pastActivity': 'Past activity',
    'myActivities.pastActivities': 'Past activities',
    'myActivities.cancelledBooking': 'Booking cancelled',
    'myActivities.cancelled': 'Cancelled',
    
    // Admin
    'admin.title': 'Admin Panel',
    'admin.summary': 'Summary',
    'admin.revenue': 'Revenue',
    'admin.users': 'Users',
    'admin.activities': 'Activities',
    'admin.creators': 'Creators',
    'admin.registrations': 'Registrations',
    'admin.searchUsers': 'Search users...',
    'admin.searchActivities': 'Search activities...',
    'admin.all': 'All',
    'admin.confirmedRevenue': 'Confirmed revenue',
    'admin.pendingRevenue': 'Pending revenue',
    'admin.revenueByCreator': 'Revenue by creator',
    'admin.revenueByMonth': 'Revenue by month',
    'admin.noRevenueData': 'No revenue data',
    'admin.payments': 'payment(s)',
    
    // Common
    'common.back': 'Back',
    'common.share': 'Share',
    'common.save': 'Save',
    'common.free': 'Free',
    'common.perPerson': 'per person',
    'common.showAllPhotos': 'Show all photos',
    'common.confirmed': 'Confirmed',
    'common.pending': 'Pending',
    'common.waiting': 'Waitlist',
  }
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations.es[key] || key;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  }, []);

  const contextValue = React.useMemo(() => ({
    language, setLanguage, t, toggleLanguage
  }), [language, t, toggleLanguage]);

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;

